"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { d: "M13.5 16.8a.6.6 0 01-.6.6h-1.8a.6.6 0 01-.6-.6v-3.6H8.541a.3.3 0 01-.208-.516l3.448-3.337a.3.3 0 01.417 0l3.466 3.337a.3.3 0 01-.208.516H13.5v3.6zM7.2 7.8h9.6V6.6H7.2v1.2z" }), "Upload");
//# sourceMappingURL=Upload.js.map